import apiClient from './authService';

export const contactService = {

  // Create single contact
  createContact: async (contactData) => {
    const response = await apiClient.post('/contacts/single', contactData);
    return response.data;
  },

  // Bulk upload contacts from Excel file
  bulkUploadExcel: async (customerId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('customerId', customerId);
    
    const response = await apiClient.post('/contacts/bulk-excel', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Get contact groups by customer ID with summary information
  getContactGroups: async (customerId) => {
    const response = await apiClient.get(`/contacts/groups`);
    return response.data;
  },

  // Download contact group as Excel
  downloadGroupContacts: async (groupId, customerId) => {
    const response = await apiClient.get(`/contacts/groups/${groupId}/download`, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Search contact groups by phone number
  searchContactGroupsByPhoneNumber: async (phoneNumber, page = 0, size = 10) => {
    const response = await apiClient.get('/contacts/search/groups', {
      params: {
        phoneNumber,
        page,
        size
      }
    });
    return response.data;
  },

  // Get contact group details
  getContactGroupDetails: async (groupId) => {
    const response = await apiClient.get(`/contacts/groups/${groupId}`);
    return response.data;
  },

  // Get contact by ID
  getContactById: async (contactId) => {
    const response = await apiClient.get(`/contacts/${contactId}`);
    return response.data;
  },

  // Update contact
  updateContact: async (contactId, contactData) => {
    const response = await apiClient.put(`/contacts/${contactId}`, contactData);
    return response.data;
  },

  // Delete contact
  deleteContact: async (contactId) => {
    const response = await apiClient.delete(`/contacts/${contactId}`);
    return response.data;
  },

  // Get all contacts with pagination (chatActiveOnly: only contacts visible in chat sidebar)
  getContacts: async (page = 0, size = 10, chatActiveOnly = false) => {
    const response = await apiClient.get('/contacts', {
      params: {
        page,
        size,
        chatActiveOnly
      }
    });
    return response.data;
  },

  setChatActive: async (contactId, isChatActive = true) => {
    const response = await apiClient.patch(`/contacts/${contactId}/chat-active`, { isChatActive });
    return response.data;
  },

  // Get groups for a specific contact by phone number
  getGroupsForContact: async (phoneNumber) => {
    const response = await apiClient.get('/contacts/search/groups', {
      params: {
        phoneNumber,
        page: 0,
        size: 100
      }
    });
    return response.data.content || [];
  }
};
